import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to the element matching `location.hash` when the route or hash
 * changes. React Router v6 does not do this automatically.
 *
 * Runs once per location change. Falls back gracefully when the element
 * doesn't exist (e.g. hash points at a section that hasn't mounted yet —
 * we just don't scroll).
 */
export function useHashScroll() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    // Defer to next tick so the route's content has time to mount before
    // we look for the target element.
    const id = setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 50);
    return () => clearTimeout(id);
  }, [pathname, hash]);
}
